<div id="article" class="template">
	<div class="articlebody">
		<p style="text-align: center;">For order inquires, email us at <a href="mailto:info@zmax.com"><span class="__cf_email__" data-cfemail="b2dbdcd4ddf2c8dfd3ca9cd1dddf">info@zmax.com</span></a></p>
		<p style="text-align: center;">For technical questions, please submit the below contact form</p>
		<p style="text-align: center;"><em><small>(Business hours: 8:30am-5:00pm EST; messages after hours will be returned next business day)</small></em></p>
	</div>

	<div class='contact-thank-you hidden'>
		<h2>Thank you for getting in touch!</h2>
		<p>We appreciate you contacting us. One of our colleagues will get back to you shortly.</p>
		<p>Have a great day!</p>
	</div>

	<form class='contact-form' name='contact' method='POST' netlify data-netlify='true' netlify-honeypot='honey-boo-boo' data-netlify-recaptcha='true'>
		<p class='hidden'>
			<input type='hidden' name='form-name' value='contact' />
			<input type='hidden' name='email' value='info@zmax.com' />
			<label> Don't fill this out if you're human: <input name='honey-boo-boo' /> </label>
		</p>
		<p>
		<label>First Name<sup>*</sup><input type='text' required minlength='2' name='contact-first-name' oninvalid="this.setCustomValidity('Enter First Name')" oninput="this.setCustomValidity('')" /></label>
		</p>
		<p>
			<label>Last Name<sup>*</sup><input type='text' required minlength='2' name='contact-last-name' oninvalid="this.setCustomValidity('Enter Last Name')" oninput="this.setCustomValidity('')" /></label>
		</p>
		<p>
			<label>Phone<sup>*</sup> <input type='tel' required minlength='10' name='contact-phone' oninvalid="this.setCustomValidity('Enter Valid U.S. Phone Number')" oninput="this.setCustomValidity('')" /></label>
		</p>
		<p>
			<label>Email<sup>*</sup> <input type='email' required minlength='2' name='contact-email' oninvalid="this.setCustomValidity('Enter Valid Email Address')" oninput="this.setCustomValidity('')" /></label>
		</p>
		<p>
			<label>Message<sup>*</sup><textarea required name='contact-message' cols='1' rows='6' minlength='2' maxlength='750' oninvalid="this.setCustomValidity('Enter Message No More than 750 Characters')" oninput="this.setCustomValidity('')"></textarea></label>
			<span style='font-size: small; font-weight: normal; color: #ccc;'>Please limit your response to 750 characters.</span>
		</p>
		<div class="requiredmessage" style='font-size: small; font-weight: normal;'><p>* Indicates a required field</p></div>
		<div data-netlify-recaptcha='true'></div>
		<p>
			<button type='submit' style='font-size: 12px;
			font-family: "usual",sans-serif;
			font-weight: 400;
			text-transform: uppercase;
			border-radius: 0;
			background-color: #d71920;
			border-color: #c5171d;
			padding: 6px 12px;
			color: white !important;
			margin-top: 12px;
			'>Submit</button>
		</p>
		<div class="captchatext">
			This site is protected by reCAPTCHA and the Google
			<a href="https://policies.google.com/privacy" hidefocus="true" style="outline: none;">Privacy Policy</a> and
			<a href="https://policies.google.com/terms" hidefocus="true" style="outline: none;">Terms of Service</a> apply.
		</div>
	</form> 

	<script>

		const handleSubmit = (event) => {
			event.preventDefault();

			const myForm = event.target;
			const formData = new FormData(myForm);
			
			fetch('/lib/image/favicon/favicon-16x16.png', {
				method: "POST",
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
				body: new URLSearchParams(formData).toString(),
			})
				.then(( _data )  => {
					console.log( 'Form Submit:')
					console.log( _data )

					document.querySelector( '.contact-form' ).classList.add( 'hidden' );
					document.querySelector( '.contact-thank-you' ).classList.remove( 'hidden' );
					window.scrollToAnchor( 0, 0 );
				})
				.catch(( _error ) => alert( _error ));
		};

		document.querySelector("form").addEventListener("submit", handleSubmit );

	 </script>
</div>



<style>

	:where( form ),
	:where( form ) p,
	:where( form ) label 
	{
		color: #777;
		width: 100%;
		font-style: normal;
		font-weight: 400;
	}
	
	:where( form ) input, 
	:where( form ) textarea {
		width: 100%;
		background-color: #fafafa;
		border: 1px solid #ccc;
 	   border-radius: 4px;
	}



</style>